/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const language = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.16 6.094h2.992c.38 0 .736.278.829.648l.427 1.712a.856.856 0 0 1 .007.384.866.866 0 0 1-.836.679h-.615l-.329 1.647-.252 1.417M1.16 6.094a6.55 6.55 0 0 0 .089 3.228 6.57 6.57 0 0 0 2.134 3.26M1.16 6.093A6.58 6.58 0 0 1 4.625 1.68 6.524 6.524 0 0 1 7.54 1a6.575 6.575 0 0 1 4.607 1.906M3.383 12.58a6.526 6.526 0 0 0 1.792 1.047 6.573 6.573 0 0 0 5.8-.546L15 15l-1.917-4.029c.24-.386.439-.795.593-1.22m0 0a6.529 6.529 0 0 0-.431-5.4 6.434 6.434 0 0 0-1.1-1.445m1.53 6.846h-2.342a.863.863 0 0 1-.843-.715l-.45-2.71h-.9a.868.868 0 0 1-.83-1.062l.427-1.711a.875.875 0 0 1 .83-.648h2.579"
    />
  </svg>
)
export default language
